import React from 'react';

import { ReactComponent as FacebookIcon } from '../../images/facebook-logo.inline.svg';
import { ReactComponent as TwitterIcon } from '../../images/twitter-logo.inline.svg';
import { ReactComponent as LinkedInIcon } from '../../images/linkedin-logo.inline.svg';
import { ReactComponent as EmailIcon } from '../../images/email.inline.svg';
import { generateLinkForShareOnSocial } from './shareModal.helpers';

export const FACEBOOK = 'facebook';
export const TWITTER = 'twitter';
export const LINKEDIN = 'linkedin';
export const EMAIL = 'email';

export const SOCIAL_MEDIA = [FACEBOOK, TWITTER, LINKEDIN, EMAIL];

export const SOCIAL_MEDIA_ICONS = {
  [FACEBOOK]: {
    icon: <FacebookIcon />,
    getShareLink: (baseUrl) => generateLinkForShareOnSocial(baseUrl, FACEBOOK),
    name: 'Facebook',
  },
  [TWITTER]: {
    icon: <TwitterIcon />,
    getShareLink: (baseUrl) => generateLinkForShareOnSocial(baseUrl, TWITTER),
    name: 'Twitter',
  },
  [LINKEDIN]: {
    icon: <LinkedInIcon />,
    getShareLink: (baseUrl) => generateLinkForShareOnSocial(baseUrl, LINKEDIN),
    name: 'LinkedIn',
  },
  [EMAIL]: {
    icon: <EmailIcon />,
    getShareLink: (baseUrl) => generateLinkForShareOnSocial(baseUrl, EMAIL),
    name: 'Email',
  },
};

export const CIRCLE_WIDTH = 60;
export const SOCIAL_MEDIA_ICONS_COUNT = 4;
